package ru.chm.gradereport.ui.screens.home

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.ui.window.Dialog
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ru.chm.gradereport.model.CourseDto
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.AppTextField
import ru.chm.gradereport.ui.components.MutedText
import ru.chm.gradereport.ui.components.PrimaryButton
import ru.chm.gradereport.ui.components.SecondaryButton
import ru.chm.gradereport.ui.components.SelectableText
import ru.chm.gradereport.ui.components.SoftDeleteButton
import ru.chm.gradereport.ui.theme.GradeTheme
import ru.chm.gradereport.ui.theme.GreenAccent

@OptIn(ExperimentalLayoutApi::class)
@Composable
internal fun CourseListCard(
    course: CourseDto,
    isAdmin: Boolean,
    onOpen: () -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val colors = GradeTheme.colors
    AppCard(modifier = modifier.fillMaxWidth().padding(bottom = 4.dp)) {
        SelectableText(
            text = course.name,
            color = colors.textPrimary,
            fontWeight = FontWeight.Bold,
            fontSize = 18.sp,
        )
        if (course.description.isNotBlank()) {
            MutedText(course.description, modifier = Modifier.padding(top = 4.dp))
        }
        MutedText(
            "Студентов: ${course.studentCount}",
            modifier = Modifier.padding(top = 8.dp),
        )
        if (course.reviewerNames.isNotEmpty()) {
            MutedText("Проверяющие: ${course.reviewerNames.joinToString()}")
        }
        SelectableText(
            text = "Публичная ссылка: #/public/${course.publicToken}",
            color = GreenAccent,
            fontSize = 11.sp,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.padding(top = 8.dp).fillMaxWidth(),
        )
        SelectableText(
            text = "ДЗ: #/hw/${course.homeworkToken.ifBlank { course.publicToken }}",
            color = GreenAccent,
            fontSize = 11.sp,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.padding(top = 2.dp).fillMaxWidth(),
        )
        FlowRow(
            modifier = Modifier.fillMaxWidth().padding(top = 12.dp),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            PrimaryButton("Открыть", onClick = onOpen)
            if (isAdmin) {
                SecondaryButton(text = "Редактировать", onClick = onEdit)
                SoftDeleteButton(text = "Удалить", onClick = onDelete)
            }
        }
    }
}

@Composable
internal fun EditCourseDialog(
    course: CourseDto,
    onDismiss: () -> Unit,
    onConfirm: (name: String, description: String) -> Unit,
) {
    var name by remember(course.id) { mutableStateOf(course.name) }
    var description by remember(course.id) { mutableStateOf(course.description) }
    val colors = GradeTheme.colors

    Dialog(onDismissRequest = onDismiss) {
        AppCard(modifier = Modifier.fillMaxWidth().padding(horizontal = 12.dp).widthIn(max = 480.dp)) {
            SelectableText(
                text = "Редактировать курс",
                color = colors.textPrimary,
                fontWeight = FontWeight.Bold,
                fontSize = 20.sp,
            )
            MutedText(
                "Публичные ссылки и токены не меняются",
                modifier = Modifier.padding(top = 4.dp, bottom = 10.dp),
            )
            AppTextField(name, { name = it }, "Название", modifier = Modifier.padding(top = 4.dp))
            AppTextField(description, { description = it }, "Описание", modifier = Modifier.padding(top = 8.dp))
            Row(
                modifier = Modifier.fillMaxWidth().padding(top = 16.dp),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                SecondaryButton(text = "Отмена", onClick = onDismiss, modifier = Modifier.weight(1f))
                PrimaryButton(
                    text = "Сохранить",
                    enabled = name.isNotBlank(),
                    onClick = { onConfirm(name.trim(), description.trim()) },
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}
